import { render, staticRenderFns } from "./JobOfferSlider.vue?vue&type=template&id=40ec6fb9&scoped=true&"
import script from "./JobOfferSlider.vue?vue&type=script&lang=js&"
export * from "./JobOfferSlider.vue?vue&type=script&lang=js&"
import style0 from "./JobOfferSlider.vue?vue&type=style&index=0&id=40ec6fb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec6fb9",
  null
  
)

export default component.exports